import React from "react";
import logo_eco from "../img/Logo eco by assur bon plan.png"
import logo_abp from "../img/Logo assur bon plan.png"
import DataDevis from "../dataDevis";
import cadenas from "../img/Cadenas.svg"
import mastercard from "../img/mastercard.svg"
import visa from "../img/visa.svg"
import certification from "../img/certification.svg"
import socgen from "../img/societe generale.svg"
import DataSolly from "../dataSolly";

export const CbLogos = (p) => <div className="cbLogo">
    <img src={cadenas}/> Paiement 100% sécurisé <img src={mastercard}/>
    <img src={visa}/><br/><img src={certification}/> Certifié <img src={socgen}/>
</div>

export default class FrontRecap extends React.Component {
    
    constructor(props) {
        super(props);
    }

    value(field,deflt='') {
        const devis = this.props.devis
        const params = devis.params
        const type = devis.getType(field)
        if ( typeof type === 'object' ) {
            return type[params[field]] || deflt
        }

        return devis.getDisplayValue(field) || deflt
    }

    render() {
        const {setPage,devis} = this.props
        const solly = devis.getSolly()
        const oneColumn = ! solly.hasSolly()
        const params = devis.params
        const selectedOptions = params.selectedOptions || []
        return <table className={ oneColumn ? 'recaptable onecolumn' : 'recaptable' }>
                <thead>
                    <tr><th><img src={logo_eco}/></th><th></th><th><img src={logo_abp}/></th></tr>
                </thead>
                <tbody>
                    <tr><td>Récupitulatif</td><td></td><td>Récapitulatif</td></tr>
                    <tr>
                        <td>
                            <label>Votre deux-roues <a onClick={()=>{ setPage('vehicule') }}>Modifier</a>
                            <span>{this.value('marque')} {this.value('modele')} ({this.value('cylindree')})</span>
                            </label>
                            {( params.periodicite && params.formule && devis.toPayMonthlyYearlyFormule())?<>
                                <label>Votre formule <b className="price">{devis.toPayMonthlyYearlyFormule()} €</b>
                                <span>
                                    <b>{(params.periodicite=='M')?'Mensuel':'Annuel'}</b><br/>
                                    <i>{DataDevis.zFormToDisplay[params.formule]}</i>
                                    {DataDevis.zFormToExplain[params.formule]}
                                </span>
                                </label>
                                <label>Vos options <b className="price">{devis.toPayMonthlyYearlyOptions()} €</b>
                                <span>
                                    {selectedOptions.map( code => <React.Fragment key={code}>{DataDevis.optionCodeToTitle[code]}<br/></React.Fragment>)}
                                    
                                </span>
                                </label>
                            </>:<>
                                <label>Aucune formule choisie</label>
                            </>}
                        </td>
                        <td></td>
                        <td>
                            <label>Votre deux-roues <a onClick={()=>{ setPage('vehicule') }}>Modifier</a>
                            <span>{this.value('marque')} {this.value('modele')} ({this.value('cylindree')})</span>
                            </label>
                            {( params.periodicite && params.formule && solly.hasTarifs() )?<>
                                <label>Votre formule <b className="price">{DataDevis.fancyPrice(solly.toPayMonthlyYearlyFormule())} €</b>
                                    <span>
                                        <b>{(params.periodicite=='M')?'Mensuel':'Annuel'}</b><br/>
                                        <i>{DataSolly.zFormToDisplay[params.formule]}</i>
                                        {DataSolly.zFormToExplain[params.formule]}
                                    </span>
                                </label>
                                <label>Vos options <b className="price">{DataDevis.fancyPrice(solly.toPayMonthlyYearlyOptions())} €</b>
                                    <span>
                                        
                                    </span>
                                </label>

                            </> : <label>Aucune formule choisie</label>}
                        </td>
                    </tr>
                    <tr>
                        <td className="prices">
                            {devis.toPayMonthlyYearlyFormule()?<>
                                {(params.periodicite=='M')?<>
                                    <b>{devis.toPayMonthly()}</b> par mois<br/>
                                    <b>{devis.toPayYearly()}</b> par an TTC*<br/>
                                </>:<>
                                    <b>{devis.toPayYearly()}</b> par an TTC*<br/>
                                </>}
                                * Frais de gestion et courtage inclus

                                <button
                                    className="subscribe"
                                    onClick={()=>this.props.setPage('details1')}>Souscrire cette offre</button>
                                <CbLogos/>
                                <button 
                                    className="receive_devis"
                                    onClick={()=>this.props.setPage('receive')}
                                    >Enregistrer<br/>&<br/>Recevoir mon devis</button>

                                    {(params.periodicite=='M')?<p>
                                    * L'acompte de <b>{devis.toPay()} €</b> inclut les frais de gestion et de
                                    courtage ainsi que les deux premiers mois. Puis, par mois, à
                                    partir du 3ème mois : <b>{devis.toPayMonthly()} €</b></p>:<></>}
                                </>:<></>}
                        </td>
                        <td></td>
                        <td className="prices">
                            {solly.hasTarifs() ?<>

                                {(params.periodicite=='M')?<>
                                    <b>{DataDevis.fancyPrice(solly.toPayMonthly())}</b> par mois<br/>
                                    <b>{DataDevis.fancyPrice(solly.toPayYearly())}</b> par an TTC*<br/>
                                </>:<>
                                    <b>{DataDevis.fancyPrice(solly.toPayYearly())}</b> par an TTC*<br/>
                                </>}
                                * Frais de gestion et courtage inclus

                                <button
                                    className="subscribe"
                                    onClick={()=>setPage('subscribe_solly')}>Souscrire cette offre</button>
                                <CbLogos/>
                                <button 
                                    className="receive_devis"
                                    onClick={()=>this.props.setPage('receive2')}
                                    >Enregistrer<br/>&<br/>Recevoir mon devis</button>

                                    {(params.periodicite=='M')?<p>
                                    * L'acompte de <b>{DataDevis.fancyPrice(solly.toPay())} €</b> inclut les frais de gestion et de
                                    courtage ainsi que le premier mois. Puis, par mois, à
                                    partir du 2ème mois : <b>{DataDevis.fancyPrice(solly.toPayMonthly())} €</b></p>:<></>}
                                    
                            </>:<></>}
                        </td>
                    </tr>
                </tbody>
        </table>
    }
}